import { Component, OnInit, Optional, Self, ChangeDetectionStrategy, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { getCurrencySymbol } from '@angular/common';
import { BaseInputComponent } from '../base-input';
import { FieldConventionService, ValidationMessageService } from 'src/app/stp/stp-app/forms';

@Component({
  selector: 'stp-input-currency',
  templateUrl: './input-currency.component.html'
})
export class InputCurrencyComponent extends BaseInputComponent implements OnInit {

  @Input() currencySymbol: string;
  @Input() step = 0.01;
  @Input() min = 0;
  @Input() max?: number;

  constructor(@Optional() @Self() ngControl: NgControl,
    fieldConventionService: FieldConventionService,
    validationMessageService: ValidationMessageService) {
    super(ngControl, fieldConventionService, validationMessageService);
  }

  ngOnInit() {
    super.ngOnInit();

    if (!this.currencySymbol) {
      this.currencySymbol = getCurrencySymbol('NZD', 'narrow');
    }
  }

  registerOnChange(fn: any) {
    super.registerOnChange((value: string) => {
      if (value === '') {
        fn(null);
      } else {
        fn(+value);
      }
    });
  }
}
